module.exports = __webpack_public_path__ + "img/lg_ring_y_i_1_0@2x.06599f12.png";